import React, { useEffect, useRef, useCallback, useState } from "react"
import { useLocation } from "react-router-dom"
import PropTypes from "prop-types"

import Input from "components/shared/Inputs/Inputs"
import {
  Col,
  Card,
  CardBody,
  Container,
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from "reactstrap"
import SimpleBar from "simplebar-react"
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link, useNavigate, useParams } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

import AuthService from "../../services/Auth.service"

const readSessionFlags = () => {
  const user = AuthService.getCurrentUser()
  const empresas = AuthService.getLinkedEmpresas(user)
  const DS_STATUS = user != null ? user.user.DS_STATUS : null
  const checkempresa = empresas.length > 0 ? empresas[0].OID_EMPRESA : null
  const cpfDigits = (user?.user?.DS_CPF || "").replace(/\D/g, "")
  const phoneDigits = (user?.user?.NR_TELEFONE || "").replace(/\D/g, "")
  const hasIdentificationData =
    cpfDigits.length === 11 && phoneDigits.length >= 10
  const needsIdentification =
    (DS_STATUS == 1 || DS_STATUS == 2) && !hasIdentificationData
  return { checkempresa, DS_STATUS, needsIdentification }
}

const SidebarContent = props => {
  const { checkempresa, DS_STATUS, needsIdentification } = readSessionFlags()
  const [password, setPassword] = useState("")
  const [passwordEntered, setPasswordEntered] = useState(false)

  let navigate = useNavigate()

  const [modalmapa, setmodalmapa] = useState(false)
  const [modalgateway, setmodalgateway] = useState(false)

  const toggleViewModalMapa = () => {
    setmodalmapa(!modalmapa)
  }
  const toggleViewModalGateway = () => {
    setmodalgateway(!modalgateway)
  }

  const handlePasswordChange = e => {
    setPassword(e.target.value)
  }

  const handlePasswordSubmit = () => {
    if (password === "token") {
      setPasswordEntered(true)
      setmodalmapa(!modalmapa)
      navigate("/mapa")
    } else {
      alert("Senha inválida")
    }
  }

  const handlePasswordSubmitGateway = () => {
    if (password === "token") {
      setPasswordEntered(true)
      setmodalgateway(!modalgateway)
      navigate("/configuracao/gateway")
    } else {
      alert("Senha inválida")
    }
  }

  const ref = useRef()
  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      // Ignora links que só abrem modais e não representam uma rota real
      // (marcados com data-no-active). Eles usam to="#", que o react-router
      // renderiza como o pathname ATUAL (o "#" vazio é descartado em
      // createPath), ficando idêntico à rota corrente e causando match
      // indevido — ex.: "Mapas" ficando ativo em /ordem-servico.
      if (items[i].getAttribute("data-no-active") !== null) {
        continue
      }
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  // Fecha a gaveta ao navegar. No desktop é no-op: `sidebar-enable` não tem
  // efeito acima de 992px, então não é preciso checar viewport aqui.
  function removeSidebar() {
    props.onCloseMobileMenu?.()
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {/* Recolher / expandir o menu — primeiro item. Aberto: só o ícone
                alinhado à direita (via CSS). Recolhido: rótulo "Expandir menu"
                (aparece como nos demais itens). ◀ recolhe, ▶ expande.
                Escondido no mobile (d-none d-lg-block): lá o menu é uma gaveta
                que abre/fecha pelo hambúrguer, e o rail de 70px não faz sentido. */}
            <li
              className="menu-toggle-item d-none d-lg-block"
              onClick={props.onToggleMenu}
            >
              <Link
                to="#"
                data-no-active
                onClick={e => e.preventDefault()}
                aria-label={
                  props.sidebarType === "condensed"
                    ? props.t("Expandir menu")
                    : props.t("Recolher menu")
                }
              >
                <i
                  className={
                    props.sidebarType === "condensed"
                      ? "bx bx-chevrons-right"
                      : "bx bx-chevrons-left"
                  }
                ></i>
                <span>
                  {props.sidebarType === "condensed"
                    ? props.t("Expandir menu")
                    : props.t("Recolher menu")}
                </span>
              </Link>
            </li>

            <li className="menu-title">{props.t("Menu")} </li>

            <li onClick={removeSidebar}>
              <Link to="/" activeClassName="active">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboards")}</span>
              </Link>
            </li>

            {DS_STATUS == 10 ? (
              <>
                <li onClick={removeSidebar}>
                  <Link to="/condominios">
                    <i className="bx bxs-building-house"></i>
                    <span>{props.t("Condomínios")}</span>
                  </Link>
                </li>
                <li onClick={removeSidebar}>
                  <Link to="/sindicos">
                    <i className="bx bx-user-circle"></i>
                    <span>{props.t("Gerenciar Síndicos")}</span>
                  </Link>
                </li>
              </>
            ) : null}

            {DS_STATUS == 10 ? (
              <>
                <li onClick={removeSidebar}>
                  <Link to="#" data-no-active onClick={toggleViewModalMapa}>
                    <i className="bx bx-map"></i>
                    <span>{props.t("Mapas")}</span>
                  </Link>
                  {/* <li onClick={toggleViewModalSindico}>
          <i className="bx bx-map"></i>
          <span>{props.t("Mapas")}</span>
        </li> */}
                </li>
              </>
            ) : null}

            {checkempresa != null && DS_STATUS == 1 ? (
              <>
                <li onClick={removeSidebar}>
                  <Link to="/Moradores">
                    <i className="bx bxs-user-detail"></i>
                    <span>{props.t("Moradores")}</span>
                  </Link>
                </li>
              </>
            ) : null}

            {needsIdentification ? (
              <>
                <li className="menu-title">{props.t("Identificação")} </li>

                <li onClick={removeSidebar}>
                  <Link to="/identificacao">
                    <i className="bx bxs-user-detail"></i>
                    <span className="badge rounded-pill bg-danger float-end">
                      1
                    </span>
                    <span>{props.t("Identificacao")}</span>
                  </Link>
                </li>
              </>
            ) : null}

            {DS_STATUS == 10 ? (
              <>
                <li className="menu-title">{props.t("Cadastros")}</li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bxs-eraser"></i>

                    <span>{props.t("Cadastros")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/#" className="has-arrow ">
                        {props.t("Módulo")}{" "}
                        <i className="mdi-chevron-right has-content"></i>
                      </Link>

                      <ul className="sub-menu">
                        <li onClick={removeSidebar}>
                          <Link to="/cadastro/modulo/fabricantelora">
                            {props.t("Fabricante LORA")}
                          </Link>
                        </li>

                        <li onClick={removeSidebar}>
                          <Link to="cadastro/modulo/equipamentolora">
                            {props.t("Modulos LORA")}
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li onClick={removeSidebar}>
                      <Link to="/cadastro/hidrometro">
                        {props.t("Medidores")}
                      </Link>
                    </li>
                    <li onClick={removeSidebar}>
                      <Link to="/cadastro/vistorias">
                        {props.t("Vistorias")}
                      </Link>
                    </li>
                    <li onClick={removeSidebar}>
                      <Link to="/cadastro/equipamentokit">
                        {props.t("Equipamento Kit")}
                      </Link>
                    </li>
                  </ul>
                </li>
              </>
            ) : null}

            {DS_STATUS == 10 ? (
              <>
                <li className="menu-title">Configuração</li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bxs-wrench"></i>

                    <span>{props.t("Configuração")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li onClick={removeSidebar}>
                      <Link to="/configuracao/payload">
                        {props.t("Payloads")}
                      </Link>
                    </li>
                    <li onClick={removeSidebar}>
                      <Link to="/calibragem">{props.t("Calibração")}</Link>
                    </li>

                    <li onClick={removeSidebar}>
                      <Link to="/configuracao/acoesequipamentos">
                        {props.t("Ações Equipamentos")}
                      </Link>
                    </li>
                    <li onClick={removeSidebar}>
                      <Link
                        //to="/configuracao/gateway"
                        to="#"
                        data-no-active
                        onClick={toggleViewModalGateway}
                      >
                        {props.t("Gateway")}
                      </Link>
                    </li>
                    <li onClick={removeSidebar}>
                      <Link to="/cadastro/leituramanual">
                        {props.t("Leitura Manual")}
                      </Link>
                    </li>
                  </ul>
                </li>
              </>
            ) : null}

            {DS_STATUS == null ||
            DS_STATUS == 10 ||
            (DS_STATUS == 1 && !needsIdentification) ? (
              <>
                <li className="menu-title">Informações</li>

                <li onClick={removeSidebar}>
                  <Link to="/consumo">
                    <i className="bx bx-receipt"></i>
                    <span>{props.t("Consumo")}</span>
                  </Link>
                </li>
                {DS_STATUS == 10 ? (
                  <li onClick={removeSidebar}>
                    <Link to="/relatorio/consumo">
                      <i className="bx bx-file"></i>
                      <span>Relatório</span>
                    </Link>
                  </li>
                ) : null}
              </>
            ) : null}

            {DS_STATUS == 10 ? (
              <li onClick={removeSidebar}>
                <Link to="/ordem-servico">
                  <i className="bx bx-clipboard"></i>
                  <span>{props.t("Ordens de Serviço")}</span>
                </Link>
              </li>
            ) : null}
          </ul>
        </div>
      </SimpleBar>

      <Modal
        isOpen={modalmapa}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        tabIndex="-1"
        toggle={() => {
          setmodalmapa(!modalmapa)
        }}
      >
        <div>
          <ModalHeader
            toggle={() => {
              setmodalmapa(!modalmapa)
            }}
          >
            Entrar em Mapas
          </ModalHeader>
          <ModalBody>
            <p className="mb-2"></p>

            <div>
              {!passwordEntered ? (
                <>
                  <div className="password-input">
                    <Input
                      type="password"
                      placeholder="Senha"
                      value={password}
                      onChange={handlePasswordChange}
                    />
                    {/* <button className="confirm-button" onClick={handlePasswordSubmit} >Entrar</button> */}
                    {/* <button onClick={handlePasswordSubmit}>Submit</button> */}
                  </div>
                  <div style={{ margin: "5px" }}>
                    <button
                      className="confirm-button"
                      onClick={handlePasswordSubmit}
                    >
                      Entrar
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="password-input">
                    <Input
                      type="password"
                      placeholder="Senha"
                      value={password}
                      onChange={handlePasswordChange}
                    />
                    {/* <button className="confirm-button" onClick={handlePasswordSubmit} >Entrar</button> */}
                    {/* <button onClick={handlePasswordSubmit}>Submit</button> */}
                  </div>
                  <div style={{ margin: "5px" }}>
                    <button
                      className="confirm-button"
                      onClick={handlePasswordSubmit}
                    >
                      Entrar
                    </button>
                  </div>
                </>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="secondary"
              onClick={() => {
                setmodalmapa(!modalmapa)
              }}
            >
              Fechar
            </Button>
          </ModalFooter>
        </div>
      </Modal>

      <Modal
        isOpen={modalgateway}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        tabIndex="-1"
        toggle={() => {
          setmodalgateway(!modalgateway)
        }}
      >
        <div>
          <ModalHeader
            toggle={() => {
              setmodalgateway(!modalgateway)
            }}
          >
            Entrar em gateway
          </ModalHeader>
          <ModalBody>
            <p className="mb-2"></p>

            <div>
              {!passwordEntered ? (
                <>
                  <div className="password-input">
                    <Input
                      type="password"
                      placeholder="Senha"
                      value={password}
                      onChange={handlePasswordChange}
                    />
                    {/* <button className="confirm-button" onClick={handlePasswordSubmit} >Entrar</button> */}
                    {/* <button onClick={handlePasswordSubmit}>Submit</button> */}
                  </div>
                  <div style={{ margin: "5px" }}>
                    <button
                      className="confirm-button"
                      onClick={handlePasswordSubmitGateway}
                    >
                      Entrar
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="password-input">
                    <Input
                      type="password"
                      placeholder="Senha"
                      value={password}
                      onChange={handlePasswordChange}
                    />
                    {/* <button className="confirm-button" onClick={handlePasswordSubmit} >Entrar</button> */}
                    {/* <button onClick={handlePasswordSubmit}>Submit</button> */}
                  </div>
                  <div style={{ margin: "5px" }}>
                    <button
                      className="confirm-button"
                      onClick={handlePasswordSubmit}
                    >
                      Entrar
                    </button>
                  </div>
                </>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="secondary"
              onClick={() => {
                setmodalgateway(!modalgateway)
              }}
            >
              Fechar
            </Button>
          </ModalFooter>
        </div>
      </Modal>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  onToggleMenu: PropTypes.func,
  onCloseMobileMenu: PropTypes.func,
  sidebarType: PropTypes.string,
}

export default withRouter(withTranslation()(SidebarContent))
